var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEnable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_enable",
    d: "M480.26,342.5h0a10,10,0,1,0,9.966,10.034V352.5a9.98,9.98,0,0,0-9.958-10Zm4.472,8.152-5.054,5.055a.96.96,0,0,1-1.356,0l-2.61-2.61a.959.959,0,0,1,1.356-1.356L479,353.673l4.377-4.377a.959.959,0,0,1,1.355,1.356Z",
    transform: "translate(-470.226 -342.5)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEnable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_enable.09b1542ad7be40265b62003a684f40e2.svg";